if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove(
        'hidden',
      );

      const id = this.form.querySelector('[name=id]').value;
      const quantity = parseInt(document.querySelector('[data-cart-quantity]')?.value) || 1;
      let properties = {};

      [...this.form.querySelectorAll('[name^="properties"]')].map(property => {
        const key = property.getAttribute('name')?.replace('properties[', '')?.replace(']', '');
        const value = property.value;

        properties[key] = value;
      })

      await window.theme
        .addToCart([{
          id,
          quantity: quantity || 0,
          properties
        }])
        .then((result) => {
          if (result.error) {
            this.handleErrorMessage(result.error);

            const soldOutMessage =
              this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            soldOutMessage.textContent = result.error;
            this.error = true;
            return;
          }
          this.error = false;
          const modal = this.closest('quick-add-modal, modal-dialog');
          if (modal) {
            modal.hide(true);
          }
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add(
            'hidden'
          );
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
